export const EDIT_LIBRARY_PREFIX = 'libraries'
export const LANDING_LIBRARY_PREFIX = 'vc'

const APP_ROUTES = Object.freeze({
  home: '/',
  contacts: '/contacts',
  shopify: '/shopify', // deprecated
  notFound: '/not-found',
  clp: '/c/:link',
  clpSuccess: '/c/:link/success',
  videoLibraries: `/${EDIT_LIBRARY_PREFIX}`,
  libraryEdit: `/${EDIT_LIBRARY_PREFIX}/:vcpId/:videoid?`,
  libraryPlayer: `/${LANDING_LIBRARY_PREFIX}/:id/:videoid?`,
  pluginsList: '/plugins',
  pluginEdit: '/v2/plugins/:pluginId',
  campaignList: '/campaign',
  campaignEdit: '/campaigns/:link/edit',
  legacyCampaignEdit: '/campaign/:link',
  submissionsList: '/media',
  legacyMediaList: '/media/legacy', // deprecated
  legacyMediaDetails: '/media/:mediaId', // deprecated I think
  shareVideo: '/share/:pageType?/:mediaId/:fileName',
  organization: '/organization',
  insights: '/insights', // deprecated
  admin: '/clients',
  signUp: '/signup/:title?',
  signUpTwo: '/plan',
  forgotPassword: '/forgot/password',
  resetPassword: '/reset/password/:token',
  videos: '/videos', // deprecated? maybe needed in legacy
  videoDetails: '/videos/:uuid', // deprecated? maybe needed in legacy
  videoFilter: '/campaign/videos/:filterId', // deprecated? what is this
  pluginDetails: '/plugin/:uuid', // legacy, deprecated
  billing: '/billing',
  settings: '/settings',
  newAdminPanel: '/admin-panel', // was never launched
  changePassword: '/change/password',
  legacyClp: '/:id', 
  legacyClpPreview: '/view/:id',
  legacyVlp: '/v/:fileName',
  editing: '/editing',
  campaignSubmissionlp: '/cs/:submissionId',
});

export default APP_ROUTES;



// WEBPACK FOOTER //
// ./src/app_routes.js